import { action, observable } from 'mobx';

import { URLS } from '@constants';

import { EResponseStatus, EMainMenuBadge } from '@enums';

import { Log } from '@utils';

import { getCurrentUser } from '@stores';

import { Api } from '@api';

import { IAppItemResponse } from '@interfaces';

import { IMainMenuApp, IMainMenuAppsStoreParams } from './types';

export class MainMenuAppsStore {

	@observable
	myApps: IMainMenuApp[] = [];

	@observable
	suggestApps: IMainMenuApp[] = [];

	idsIsHit: string[] = [];
	idsIsNew: string[] = [];
	idsHasNotify: string[] = [];

	@observable
	status: EResponseStatus = null;

	@action
	setStatus = (status: EResponseStatus) => {
		this.status = status;
	};

	@action
	setMyApps = (myApps: IMainMenuApp[]) => {
		this.myApps = myApps;
	};

	@action
	setSuggestApps = (suggestApps: IMainMenuApp[]) => {
		this.suggestApps = suggestApps;
	};

	fetch = async () => {
		const user = getCurrentUser() || null;

		try {
			const response = await Api.apps.fetchMainMenuApps(user || null);
			const {
				apps: myApps = [],
				recommend = [],
				hit = [],
				new: newApps = [],
				notifications,
			} = response;
			let myAppsIncludeHits = false;
			let suggestApps = [...recommend];

			if (newApps.length) {
				this.idsIsNew = newApps.map((app: IAppItemResponse) => app.ID);
			}

			if (hit.length) {
				this.idsIsHit = hit.map((app: IAppItemResponse) => app.ID);
			}

			if (notifications?.apps) {
				this.idsHasNotify = response?.notifications?.apps?.map((app: IAppItemResponse) => app.ID);
			}

			if (myApps?.length) {
				myAppsIncludeHits = !!myApps
					.filter((app) => !!hit.filter((appHit) => appHit.ID === app.ID).length)
					.length;

				this.setMyApps(this.getAdaptedApps(myApps));
			}

			if (!myAppsIncludeHits) {
				suggestApps = [...suggestApps, ...hit];
			}

			this.setSuggestApps(this.getAdaptedApps(suggestApps));
		} catch (err) {
			Log.error(`Failed in getting menu apps list; Error: ${err}`);
		}
	};

	private getAdaptedApps = (response: IAppItemResponse[]) => {
		return response.map((app: IAppItemResponse) => {
			const id = app.ID;
			let badge: EMainMenuBadge;
			const picArray = app.Pictures;

			if (this.idsIsNew?.includes(id)) {
				badge = EMainMenuBadge.APP_NEW;
			}

			if (this.idsIsHit?.includes(id)) {
				badge = EMainMenuBadge.APP_HIT;
			}

			if (this.idsHasNotify?.includes(id)) {
				badge = EMainMenuBadge.APP_NOTIFY;
			}

			return {
				id,
				url: `${URLS.APPS}/${app.ID}`,
				title: app.ShortName,
				icon: picArray?.PicIco_Text_HTML || picArray?.PicIco || picArray?.MobPic || picArray.MobPic_Text_HTML,
				badge: badge,
			};
		});
	};

	toJSON() {
		return {
			myApps: this.myApps,
			suggestApps: this.suggestApps,
		};
	}

	fromJSON(data: IMainMenuAppsStoreParams) {
		this.myApps = [...this.myApps, ...data.myApps];
		this.suggestApps = [...this.suggestApps, ...data.suggestApps];
	}

}
